/**
 * The different states our action can be in
 *
 * @author Jason Kelly [jk@interflora.dk](mailto:jk@interflora.dk)
 */
export enum ActionState {
  /**
   * Action is idle, and ready to receive click / touch
   */
  Idle = "idle",
  /**
   * Action is busy, and we are waiting for it to complete
   */
  Busy = "busy",
  /**
   * Action is disabled, and is not available for click / touch
   */
  Disabled = "disabled",
}
